module.exports = __webpack_public_path__ + "img/1-i.f11322cb.png";